<template>
    <div class="account-wrapper">
        <div class="header">
            <router-link
                to="/login"
                class="logo-link"
            >
                <img
                    class="logo"
                    src="../../assets/img/logo.svg"
                    alt=""
                >
            </router-link>
        </div>
        <div class="main-box">
            <div class="header-box">
                找回密码
            </div>
            <div class="main-area">
                <el-steps
                    :active="current"
                    align-center
                >
                    <el-step title="身份验证" />
                    <el-step title="重置密码" />
                    <el-step title="重置成功" />
                </el-steps>
                <router-view />
            </div>
        </div>
        <div class="footer">
            <div class="copyright">
                © 2019 北京奇点在线科技有限公司&nbsp;&nbsp;&nbsp;<el-divider direction="vertical" />&nbsp;&nbsp;&nbsp;&nbsp;京ICP备18055826号
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import { Divider, Steps, Step } from 'element-ui'

Vue.use(Steps)
Vue.use(Step)
Vue.use(Divider)

export default {
    name: 'Entry',
    computed: {
        current () {
            return this.$route.name.substring(1) * 1
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/account.scss";
</style>
